import { render, staticRenderFns } from "./Organisaties.vue?vue&type=template&id=bfca617c&"
import script from "./Organisaties.vue?vue&type=script&lang=js&"
export * from "./Organisaties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports